(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["factory-capabilities"] && !Shopify.designMode) return;
  try {
    
if (!window.yoborFactoryGalleryBound) {
window.yoborFactoryGalleryBound = true;
const update = (dialog, index) => {
const photos = dialog.closest('[data-factory-gallery]').querySelectorAll('[data-factory-photo]');
if (!photos.length) return;
dialog.factoryIndex = (index + photos.length) % photos.length;
const photo = photos[dialog.factoryIndex];
const image = dialog.querySelector('[data-factory-full-image]');
image.src = photo.dataset.src;
image.alt = photo.dataset.caption || '';
dialog.querySelector('[data-factory-caption]').textContent = image.alt;
dialog.querySelector('[data-factory-counter]').textContent = (dialog.factoryIndex + 1) + ' / ' + photos.length;
};
document.addEventListener('click', (event) => {
const photo = event.target.closest('[data-factory-photo]');
if (photo) {
const section = photo.closest('[data-factory-gallery]');
const dialog = section.querySelector('dialog');
dialog.factoryTrigger = photo;
update(dialog, Array.from(section.querySelectorAll('[data-factory-photo]')).indexOf(photo));
dialog.showModal();
return;
}
const dialog = event.target.closest('.yobor-factory__lightbox');
if (!dialog) return;
if (event.target.closest('[data-factory-close]') || event.target === dialog) dialog.close();
if (event.target.closest('[data-factory-prev]')) update(dialog, dialog.factoryIndex - 1);
if (event.target.closest('[data-factory-next]')) update(dialog, dialog.factoryIndex + 1);
});
document.addEventListener('keydown', (event) => {
const dialog = document.querySelector('.yobor-factory__lightbox[open]');
if (!dialog) return;
if (event.key === 'ArrowLeft') {event.preventDefault(); update(dialog, dialog.factoryIndex - 1);}
if (event.key === 'ArrowRight') {event.preventDefault(); update(dialog, dialog.factoryIndex + 1);}
});
document.addEventListener('close', (event) => {
if (event.target.matches('.yobor-factory__lightbox') && event.target.factoryTrigger) event.target.factoryTrigger.focus();
}, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["factory-page"]) return;
  try {
    
document.addEventListener('click',event=>{
const gallery=event.target.closest('[data-material-gallery]');if(!gallery)return;
const thumb=event.target.closest('[data-material-thumb]');
if(thumb){const img=gallery.querySelector('.yobor-materials__main-image');img.removeAttribute('srcset');img.src=thumb.dataset.image;img.alt=thumb.dataset.alt;gallery.querySelectorAll('[data-material-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));}
const dialog=gallery.querySelector('dialog');
if(event.target.closest('[data-material-open]')){const main=gallery.querySelector('.yobor-materials__main-image');dialog.querySelector('img').src=main.src;dialog.querySelector('img').alt=main.alt;dialog.showModal();}
if(event.target.closest('[data-material-close]')||event.target===dialog)dialog.close();
});

  } catch(e) { console.error(e); }
})();
})();
